import _slicedToArray from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useState } from 'react';
import { useMove, useDidUpdate, useMergedRef, clampUseMovePosition } from '@mantine/hooks';
import { Thumb } from '../Thumb/Thumb.js';
import useStyles from './ColorSlider.styles.js';
import { Box } from '../../Box/Box.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var ColorSlider = forwardRef(function (_a, ref) {
  var _b = _a,
      value = _b.value,
      onChange = _b.onChange,
      maxValue = _b.maxValue,
      round = _b.round,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      _b$thumbColor = _b.thumbColor,
      thumbColor = _b$thumbColor === void 0 ? "transparent" : _b$thumbColor,
      _b$__staticSelector = _b.__staticSelector,
      __staticSelector = _b$__staticSelector === void 0 ? "ColorSlider" : _b$__staticSelector,
      _b$focusable = _b.focusable,
      focusable = _b$focusable === void 0 ? true : _b$focusable,
      overlays = _b.overlays,
      classNames = _b.classNames,
      styles = _b.styles,
      className = _b.className,
      others = __objRest(_b, ["value", "onChange", "maxValue", "round", "size", "thumbColor", "__staticSelector", "focusable", "overlays", "classNames", "styles", "className"]);

  var _useStyles = useStyles({
    size: size
  }, {
    classNames: classNames,
    styles: styles,
    name: __staticSelector
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var _useState = useState({
    y: 0,
    x: value / maxValue
  }),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var getChangeValue = function getChangeValue(val) {
    return round ? Math.round(val * maxValue) : val * maxValue;
  };

  var _useMove = useMove(function (_ref) {
    var x = _ref.x;
    return onChange(getChangeValue(x));
  }),
      sliderRef = _useMove.ref;

  useDidUpdate(function () {
    setPosition({
      y: 0,
      x: value / maxValue
    });
  }, [value]);

  var handleArrow = function handleArrow(event, pos) {
    event.preventDefault();

    var _position = clampUseMovePosition(pos);

    onChange(getChangeValue(_position.x));
  };

  var handleKeyDown = function handleKeyDown(event) {
    switch (event.nativeEvent.code) {
      case "ArrowRight":
        {
          handleArrow(event, {
            x: position.x + 0.05,
            y: position.y
          });
          break;
        }

      case "ArrowLeft":
        {
          handleArrow(event, {
            x: position.x - 0.05,
            y: position.y
          });
          break;
        }
    }
  };

  var layers = overlays.map(function (overlay, index) {
    return /* @__PURE__ */React.createElement("div", {
      className: classes.sliderOverlay,
      style: overlay,
      key: index
    });
  });
  return /* @__PURE__ */React.createElement(Box, __spreadProps(__spreadValues({}, others), {
    ref: useMergedRef(sliderRef, ref),
    className: cx(classes.slider, className),
    role: "slider",
    "aria-valuenow": value,
    "aria-valuemax": maxValue,
    "aria-valuemin": 0,
    tabIndex: focusable ? 0 : -1,
    onKeyDown: handleKeyDown
  }), layers, /* @__PURE__ */React.createElement(Thumb, {
    __staticSelector: __staticSelector,
    classNames: classNames,
    styles: styles,
    position: position,
    style: {
      top: 1,
      backgroundColor: thumbColor
    },
    className: classes.sliderThumb,
    size: size
  }));
});
ColorSlider.displayName = "@mantine/core/ColorSlider";
export { ColorSlider };